import { registerLocaleData } from '@angular/common';
import { bootstrapApplication } from '@angular/platform-browser';
import localeEsCO from '@angular/common/locales/es-CO';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

registerLocaleData((localeEsCO as unknown as { default?: unknown }).default ?? localeEsCO, 'es-CO');

// Se persiste el modelo de negocio antes del bootstrap para que cualquier
// servicio o componente pueda leerlo desde sessionStorage ya en su constructor.
try {
  sessionStorage.setItem('modeloNegocio', environment.modeloNegocio);
} catch {
  /* sessionStorage bloqueado (modo privado) */
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
